<script>
    import { Button, Row, Col } from "svelte-chota";
    import Me from "./main/Me.svelte";
    import FeaturedProjects from "./projects/FeaturedProjects.svelte";
    import ContactForm from "./main/ContactForm.svelte";
    import SimpleModal from "./components/SimpleModal.svelte";
    const scrollToBottom = () =>
        window.scrollTo(0, document.body.scrollHeight - 90);

    let name = "", email = "", subject = "";
    let modalText = "", modalHeader = "", open = false;
    let feedbackUpload = false;

    function showModal(header, text) {
        modalHeader = header;
        modalText = text;
        open = true;
    }

    function clearForm() {
        name = "";
        email = "";
        subject = "";
    }

    async function handleSubmit(event) {
        if (subject.length > 0) {
            if (feedbackUpload) {
                return;
            }
            feedbackUpload = true;
            const url =
                "https://us-central1-daily-decision-wheel.cloudfunctions.net/feedback";
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: email,
                    name: name,
                    subject: subject,
                }),
            });
            const data = await response.json();
            feedbackUpload = false;
            if (data.status == "ok") {
                showModal("Success", "Your request submited");
                clearForm();
            } else {
                showModal("Error", "Something went wrong, please try again later");
            }
        } else {
            showModal("Error", "Please, specify the subject");
        }
    }
</script>

<main>
    <Row style="margin:auto; padding-top:100px;">
        <div style="margin:auto;">
            <Row style="margin:auto;">
                <Me />
            </Row>
            <Row style="margin:auto;">
                <Col class="is-center" style="padding:20px;">
                    <Button primary on:click={scrollToBottom}>E-mail Me</Button>
                </Col>
            </Row>
        </div>
    </Row>
    <Row style="margin:auto;">
        <Col
            class="ea-bold is-center bg-light"
            style="margin:auto; padding:40px; color:#000;">
            <h2>Following is a highlight of my latest personal projects:</h2>
        </Col>
    </Row>
    <FeaturedProjects />
    <div
        class="bg-light"
        style="height: 120px; display: flex; align-items: center; text-align: center;">
        <a href="/projects" style="margin:auto;">
            <Button primary>See All Projects</Button>
        </a>
    </div>
    <form on:submit|preventDefault={handleSubmit}>
        <ContactForm bind:name bind:email bind:subject bind:feedbackUpload />
    </form>
    <div style="height: 90px;" />
    <!--  -->
    <SimpleModal bind:open bind:modalHeader bind:modalText />
</main>
